import React, { useEffect, useState, useContext } from 'react'
import PageHeader from '../../components/pageHeader/PageHeader';
import PageWrapper from '../../components/pageComponents/PageWrapper';
import ModalEnabled from '../../components/modalComponents/ModalEnabled';
import SearchContainer from '../../components/pageComponents/SearchContainer';
import useDidMountEffect from '../../hooks/useDidMountEffect/useDidMountEffect';
import { useGetRequest } from '../../hooks/useGetRequest/useGetRequest';
import { useManagePostRequest } from '../../hooks/useManagePostRequest/useManagePostRequest';
import { useGenerarDescargarEliminarArchivo } from '../../hooks/useGenerarDescargarEliminarArchivo/useGenerarDescargarEliminarArchivo';
import { AuthContext } from "../../hooks/context/authContext";
import { ROLES } from "../../constants/hardCodedConstants";

import {initialAllOptionPromises, jsonNoEstaVacio, updateFiltersWithExtraData} from "../../helper/utils";
import {getAllEstadosAPI, getAllCargosAPI, 
        getAllSedesAPI, getAllTipoDocumentoPagoAPI, getAllAniosDocumentoPagoAPI,getAllPeriodosDocumentoPagoAPI,
        getListaMisDocumentosPagoAPI,exportarDocumentosPagoAPI,
        bloquearEmpleadoDocumentoPagoAPI,desBloquearEmpleadoDocumentoPagoAPI,
        descargarReporteDocumentosPagoExcelAPI
    } from '../../consumers/backendApisUrls';
import { onKeyPressEnter, jsonEstaVacio, usuarioLogueadoTieneAlgunoDeLosSiguientesRoles, notNullAndNotUndefinded, mapDropDownOptionsFromBackendToSelectOptionsNeededForLibrary } from '../../helper/utils';

import styled from "styled-components";   
import TableDocumentoPago from "./TableDocumentoPago"; 
import DescargarDocumentoPago from './modales/DescargarDocumentoPago';
const INIT_KEYS = {
    IdsTipoDocumentosPago : "IdsTipoDocumentosPago",
    IdsEstados: "IdsEstados",
    IdsCargos: "IdsCargos",
    IdsSedes: "IdsSedes",    
    IdsAnios : "IdsAnios",
    IdsPeriodos : "IdsPeriodos",
    IdsEstadosEmpleado: "IdsEstadosEmpleado"  
}


const MiDocumentoPago = () => {
    const { state } = useContext(AuthContext);
    const [formValues, setFormValues] = useState({Items: [], ExtraData: {}, filters: [], selectedFilters: {}});
    const [allFilters, setAllFilters] = useState([]);
    const [idsDocumentosConCheck, setIdsDocumentosConCheck] = useState([]);
    const [searchCriteria, setSearchCriteria] = useState("");
    const [paginator, setPaginator] = useState({CurrentPage: 1});
    const [isLoading, setIsLoading] = useState(true);
    const [managePostRequest] = useManagePostRequest();
    const [modalEnabled, setModalEnabled] = useState({isEnable: false, component: React.Fragment});
    const [hideObservarRegistroModal, setHideObservarRegistroModal] = useState(true);
    const [hideDescargarDocumentoPagoModal, setHideDescargarDocumentoPagoModal] = useState(true);
    const [executeGet] = useGetRequest();
    const [executeManagePost] = useManagePostRequest();
    const [idEmpleadoDocumentoPago, setIdEmpleadoDocumentoPago] = useState(0);
    const [downloadAndDelete] = useGenerarDescargarEliminarArchivo();
    const [usuarioLogueadoTieneRolCompensaciones, setUsuarioLogueadoTieneRolCompensaciones] = useState(false);
    //const [fromFormAdmin, setFromFormAdmin] = useState(false);
    const initialPromises = () => {
        const response = executeGet(getAllEstadosAPI());
        return [
            executeGet(getAllTipoDocumentoPagoAPI()),            
            response,
            executeGet(getAllCargosAPI()),
            executeGet(getAllSedesAPI()),
            executeGet(getAllAniosDocumentoPagoAPI()),
            executeGet(getAllPeriodosDocumentoPagoAPI()),
            response            
        ];
    }

    const init = async () => {
        setIsLoading(true);
        //setUsuarioLogueadoTieneRolCompensaciones((usuarioLogueadoTieneAlgunoDeLosSiguientesRoles(state.roleIds, [ROLES.Compensaciones.id])));
        try {            
            await initialAllOptionPromises(initialPromises, Object.values(INIT_KEYS), setAllFilters);
            await manageSearch();
            if (formValues.filters.length === 0) {
                jsonNoEstaVacio(formValues.ExtraData) &&
                updateFiltersWithExtraData(allFilters, formValues.ExtraData, handleUpdatedFilters);
            }
            setIsLoading(false);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }

    const manageSearch = async () => {
        setIsLoading(true);
        const api = getListaMisDocumentosPagoAPI();
        const payload = getPayload();
        await managePostRequest(api, payload, successManageSearchCallback);
        setIdsDocumentosConCheck([]);
        setIsLoading(false);
    }

    const successManageSearchCallback = ({data}) => {
        const {Items, ExtraData, TotalItems, FirsItemPage, LastItemPage, TotalPages, CurrentPage} = data;
        setFormValues(lastData => ({...lastData, Items, ExtraData}));
        setPaginator({TotalItems, FirsItemPage, LastItemPage, TotalPages, CurrentPage});
        setIsLoading(false);
    }

    const getPayload = () => {
        return {
            Criteria: searchCriteria,
            Page: paginator.CurrentPage,
            ...formValues.selectedFilters
        }
    }

    const handleUpdatedFilters = (res) => {
        setFormValues(lastData => ({...lastData, filters: res}))
    }

    const handleCleanSearch = () => {
        setFormValues({...formValues, selectedFilters: null});
    }

    useDidMountEffect(() => {
        manageSearch();
    }, [paginator.CurrentPage, formValues.selectedFilters])

    useDidMountEffect(() => {
        jsonNoEstaVacio(formValues.ExtraData) && updateFiltersWithExtraData(allFilters, formValues.ExtraData, handleUpdatedFilters);
    }, [formValues.ExtraData])

    useEffect(() => {
        init();
    }, [])

    const handleExportarFile = async () => {
        const payload = getPayload();
        await downloadAndDelete(exportarDocumentosPagoAPI(), payload);
    }

    const manageSearchProxy = (response) => {
        manageSearch();
    }

    const bloquearEmpleadoDocumento = async function (IdEmpleadoDocumento) {
        let payload = {
            "IdEmpleadoDocumentoPago": IdEmpleadoDocumento
        };
        await managePostRequest(bloquearEmpleadoDocumentoPagoAPI(), payload, manageSearchProxy)
    }

    const desBloquearEmpleadoDocumento = async function (IdEmpleadoDocumento) {
        let payload = {
            "IdEmpleadoDocumentoPago": IdEmpleadoDocumento
        };
        await managePostRequest(desBloquearEmpleadoDocumentoPagoAPI(), payload, manageSearchProxy)
    }

    const toggleObservarRegistroModal = (IdEmpleadoDocumentoPago) => {
        setHideObservarRegistroModal(!hideObservarRegistroModal);
        IdEmpleadoDocumentoPago && setIdEmpleadoDocumentoPago(IdEmpleadoDocumentoPago) //if truthy  
    }

    const toggleDescargarDocumentoPagoModal = (IdEmpleadoDocumentoPago) => {
        setHideDescargarDocumentoPagoModal(!hideDescargarDocumentoPagoModal);
        IdEmpleadoDocumentoPago && setIdEmpleadoDocumentoPago(IdEmpleadoDocumentoPago)  
    }

    return (
        <>
        {hideDescargarDocumentoPagoModal === false &&
            <div className="modal-contactanos modal-response-ficha-background">
                <DescargarDocumentoPago 
                    toggleModal={toggleDescargarDocumentoPagoModal} 
                    idEmpleadoDocumentoPago={idEmpleadoDocumentoPago} 
                    refreshTable={manageSearch} 
                    fromAdminPage={false}
                    />
            </div>
        }
        <PageWrapper isLoading={isLoading}>
            <ModalEnabled
                modalEnabled={modalEnabled}
                setModalEnabled={setModalEnabled}
                refreshPage={manageSearch}
            />
            <PageHeader title="Mis Documentos de Pago"/>

            <SearchContainer
                searchCriteria={searchCriteria}
                setSearchCriteria={setSearchCriteria}
                setPaginator={setPaginator}
                manageSearch={manageSearch}
                addCleanSearch={handleCleanSearch}>
                
                
            </SearchContainer>

            <TableDocumentoPago
                formValues={formValues}
                setFormValues={setFormValues}
                extraData={formValues.ExtraData}
                setModalEnabled={setModalEnabled}
                paginator={paginator}
                setPaginator={setPaginator}
                keys={INIT_KEYS}
                idsDocumentosConCheck={idsDocumentosConCheck}
                setIdsDocumentosConCheck={setIdsDocumentosConCheck}
                manageSearch={manageSearch}
                fromAdminPage={false}
                bloquearEmpleadoDocumento={bloquearEmpleadoDocumento}
                desBloquearEmpleadoDocumento={desBloquearEmpleadoDocumento}
                toggleObservarRegistroModal={toggleObservarRegistroModal}
                toggleDescargarDocumentoPagoModal={toggleDescargarDocumentoPagoModal}
            />            

        </PageWrapper>
        </>
    )
}

export default MiDocumentoPago